import { render, staticRenderFns } from "./orderManagementDetail.vue?vue&type=template&id=0c403d82&scoped=true"
import script from "./orderManagementDetail.vue?vue&type=script&lang=js"
export * from "./orderManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./orderManagementDetail.vue?vue&type=style&index=0&id=0c403d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c403d82",
  null
  
)

export default component.exports